"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
exports.noop = function () { };
exports.idx = function (obj, accessor) {
    try {
        return accessor(obj);
    }
    catch (error) {
        return undefined;
    }
};
exports.isClient = typeof window === 'object';
exports.on = function (obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return obj.addEventListener.apply(obj, args);
};
exports.off = function (obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return obj.removeEventListener.apply(obj, args);
};
exports.ns = function (name) { return "@@libreact/" + name; };
var hasSymbols = typeof Symbol !== 'undefined';
exports.sym = function (name) {
    return hasSymbols ? Symbol(name) : exports.ns(name);
};
exports.isFn = function (fn) { return typeof fn === 'function'; };
exports.h = React.createElement;
//# sourceMappingURL=util.js.map